import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toggleToast } from "../Actions/ToggleToast";

class CustomToastContainer extends Component {
  componentDidUpdate(prevProps) {
    const { toast: toastData } = this.props;

    // Trigger toast ONLY when show changes from false → true
    if (toastData.show && toastData !== prevProps.toast) {
      const options = {
        className: `toast-${toastData.type}`,
        autoClose: 3000, // ✅ AUTO CLOSE AFTER 3 SECONDS
        onClose: () => {
          // ✅ Clear Redux toast AFTER it disappears
          this.props.toggleToast({ show: false, message: "", type: "" });
        },
      };

      switch (toastData.type) {
        case "success":
          toast.success(toastData.message, options);
          break;
        case "info":
          toast.info(toastData.message, options);
          break;
        case "warn":
          toast.warn(toastData.message, options);
          break;
        case "error":
          toast.error(toastData.message, options);
          break;
        default:
          toast(toastData.message, options);
      }
    }
  }

  render() {
    return (
      <ToastContainer
        position="top-center"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
    );
  }
}

const mapStateToProps = (state) => ({
  toast: state.mainState.toast,
});

const mapActionsToProps = {
  toggleToast,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(CustomToastContainer);
